export default "__VITE_ASSET__BjSVEo1p__"